module.exports = __webpack_public_path__ + "nc_static/media/file-pptx.eef2d5e4.svg";